import { createSlice } from '@reduxjs/toolkit';
import { logIn } from "./FormData";


const typeOfEnterSlice = createSlice({
    name:'logInFormInput',
    initialState: logIn,
    reducers: {
        formCreation: (state, action) => {
            state.push(action.payload);
        },

    }
})

export const { logInformCreation } = typeOfEnterSlice.actions;
export default typeOfEnterSlice;